module.exports = __webpack_public_path__ + "static/img/C (21).b7f655c8.png";